const getWidth = layout => layout === 'dreier' || layout === 'zweier' || layout === 'einser' ? 90 : 50

export { getWidth }


// WEBPACK FOOTER //
// ./src/components/utils.js